// extracted by mini-css-extract-plugin
module.exports = {"ExpandableDisclaimer":"ExpandableDisclaimer_ExpandableDisclaimer__Sc6w6"};